
export class Offre {

    
    id : number;
    titre: string;
    description: string;
    prix: number;
    nbr_jour: number;
    nbr_data_base: number;
    is_publish: boolean;
    description_duree: string;
    nbr_activation: number;

    constructor() {
        // super();
        this.nbr_jour = 1;
        this.nbr_data_base = 1;
    }

    
    
   
  }